import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { styled } from '@mui/system';
import MuiGrid from '@mui/material/Grid';
import Icon from '@cpg-its/ads.common.icon';
import Typography from '@cpg-its/ads.common.typography';
import { black, darkBlue, green, red, yellow } from '@cpg-its/ads.constants.colors';
const CloseButtonWrapper = styled(MuiGrid)({
    height: '1.25rem',
    width: '1.25rem',
});
const IconWrapper = styled(MuiGrid)({
    width: '2.25rem',
});
const LabelWrapper = styled(MuiGrid)({
    marginBottom: '.5rem',
});
export const BannerComponent = ({ banner = {
    description: '',
    label: '',
    noVariant: false,
    onClick: () => { },
    removable: false,
    type: undefined,
}, }) => {
    const [open, setOpen] = useState(true);
    const { description, label, noVariant, onClick, removable, type } = banner;
    let color;
    let icon;
    if (type === 'error') {
        color = red;
        icon = 'tooltip';
    }
    if (type === 'info') {
        color = darkBlue;
        icon = 'tooltip';
    }
    if (type === 'success') {
        color = green;
        icon = 'checkCircle';
    }
    if (type === 'warning') {
        color = yellow;
        icon = 'warning';
    }
    const renderCloseButton = (() => {
        if (removable) {
            return (_jsx(IconWrapper, { container: true, justifyContent: "flex-end", children: _jsx(CloseButtonWrapper, { item: true, onClick: () => {
                        setOpen(false);
                        if (onClick) {
                            onClick();
                        }
                    }, children: _jsx(Icon, { color: black, icon: "close" }) }) }));
        }
        return null;
    })();
    const renderDescription = (() => {
        if (description) {
            if (typeof description === 'string') {
                return (_jsx(Typography, { text: description, variant: noVariant ? undefined : 'body1' }));
            }
            return description;
        }
        return null;
    })();
    const renderLabel = (() => {
        if (label) {
            if (typeof label === 'string') {
                return (_jsx(MuiGrid, { item: true, children: _jsx(Typography, { text: label, variant: noVariant ? undefined : 'body1', extraBold: true }) }));
            }
            return label;
        }
        return null;
    })();
    if ((label || description) && type && open) {
        return (_jsxs(MuiGrid, { sx: {
                border: `2px solid ${color}`,
                borderRadius: '3px',
                marginTop: '.5rem',
                padding: '.625rem',
            }, container: true, children: [_jsx(IconWrapper, { container: true, item: true, children: _jsx(Icon, { color: color, icon: icon, size: "large" }) }), _jsxs(MuiGrid, { sx: {
                        width: `calc(100% - ${removable ? '4.5rem' : '2.25rem'})`,
                    }, container: true, children: [_jsx(LabelWrapper, { item: true, xs: 12, children: renderLabel }), _jsx(MuiGrid, { item: true, xs: 12, children: renderDescription })] }), renderCloseButton] }));
    }
    return null;
};
export default BannerComponent;
//# sourceMappingURL=banner.js.map